<template>
  <Layout :contained="false">
    <DefaultHeader slot="header" />

    <div class="mx-4">
      <nuxt />
    </div>

    <!-- Hide the default footer -->
    <span slot="footer"></span>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import DefaultHeader from '@/components/DefaultHeader'

export default {
  components: { Layout, DefaultHeader },
}
</script>
